import { render, staticRenderFns } from "./SupplierArchive.vue?vue&type=template&id=e7672d1a"
import script from "./SupplierArchive.vue?vue&type=script&lang=js"
export * from "./SupplierArchive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports